













































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderMain from "@/components/AppHeader/AppHeaderMain.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseDropdown from "@/components/BaseDropdown/BaseDropdown.vue";
import InputRow from "@/components/InputRow/InputRow.vue";
import Spinner from "@/components/BaseSpinner/BaseSpinner.vue";
import Alert from "@/components/BaseAlert/BaseAlert.vue";

import { Action, State } from "vuex-class";
import { ISchool, IDashboard } from "@/models/interfaces/schools";
import { IVuexState } from "@/models/interfaces/store";
import RequestState from "@/utils/mixins/RequestState";

import { eventCodeByName, EventsNames } from "@/analytics";
import amplitude from "amplitude-js";

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderMain,
    BaseButton,
    BaseDropdown,
    InputRow,
    Alert,
    Spinner
  }
})
export default class HomeView extends Mixins(RequestState) {
  @State("schools", { namespace: "schools" })
  private schools!: IVuexState<ISchool[]>;

  @State("dashboard", { namespace: "schools" })
  private dashboard!: IVuexState<IDashboard>;

  @Action("schools/fetchSchools")
  private fetchSchools!: () => Promise<{ schools: ISchool[] }>;

  @Action("schools/fetchDashboardDataForSchool")
  private fetchDashboardDataForSchool!: (
    schoolId: string
  ) => Promise<{ summary: IDashboard }>;

  private schoolId = "";

  private get schoolsOptions() {
    return this.schools.data!.map(school => ({
      value: school.schoolId,
      label: school.schoolName
    }));
  }

  private get showItems() {
    if (this.schoolsOptions.length < 1) {
      return false;
    }

    return this.schoolsOptions.length > 1 ? Boolean(this.schoolId) : true;
  }

  private items = [
    {
      color: "#f0e910",
      value: "numActivities"
    },
    {
      color: "#25a8e0",
      value: "numFriends"
    },
    {
      color: "#54c542",
      value: "numMessages"
    }
  ];

  private onLessonBtnClick() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksButtonOnMainPage)} ${
          EventsNames.UserClicksButtonOnMainPage
        }`
      );
    this.$router.push("/lessons");
  }

  private async fetchDashboard(schoolId: string) {
    await this.fetchDashboardDataForSchool(schoolId);

    if (this.hasSucceeded(this.dashboard)) {
      this.items = this.items.map(item => ({
        ...item,
        count: this.dashboard.data![item.value],
        title: this.$t(`views.home.${item.value}`)
      }));
    }
  }

  public async mounted() {
    await this.fetchSchools();

    if (this.showItems) {
      this.fetchDashboard(this.schools.data![0].schoolId);
      this.schoolId = this.schools.data![0].schoolId;
    }
  }

  @Watch("schoolId")
  private onSchoolSelected() {
    this.fetchDashboard(this.schoolId);
  }

  @Watch("$i18n.locale")
  private onNumMessagesChanged() {
    if (this.showItems) {
      this.fetchDashboard(this.schoolId);
    }
  }
}
